import { ArrayUtils } from "../../../../core/ArrayUtils";
export class ConnectionsController {
  constructor(_node) {
    this._node = _node;
    this._outputConnections = /* @__PURE__ */ new Map();
  }
  initInputs() {
    const count = this._node.io.inputs.maxInputsCount();
    this._inputConnections = this._inputConnections || new Array(count);
    while (this._inputConnections.length < count) {
      this._inputConnections.push(void 0);
    }
  }
  dispose() {
    if (this._inputConnections) {
      this._inputConnections.splice(0, this._inputConnections.length);
    }
    if (this._outputConnections) {
      this._outputConnections.clear();
    }
  }
  addInputConnection(connection) {
    if (this._inputConnections) {
      this._inputConnections[connection.input_index] = connection;
    } else {
      console.warn(`input connections array not initialized`);
    }
  }
  removeInputConnection(connection) {
    if (this._inputConnections) {
      if (connection.input_index < this._inputConnections.length) {
        this._inputConnections[connection.input_index] = void 0;
        let all_connections_after_are_undefined = true;
        for (let i = connection.input_index; i < this._inputConnections.length; i++) {
          if (this._inputConnections[i]) {
            all_connections_after_are_undefined = false;
          }
        }
        if (all_connections_after_are_undefined) {
          this._inputConnections = this._inputConnections.slice(0, connection.input_index);
        }
      } else {
        console.warn(`attempt to remove an input connection at index ${connection.input_index}`);
      }
    } else {
      console.warn(`input connections array not initialized`);
    }
  }
  inputConnection(index) {
    if (this._inputConnections) {
      return this._inputConnections[index];
    }
  }
  firstInputConnection() {
    if (this._inputConnections) {
      return ArrayUtils.compact(this._inputConnections)[0];
    } else {
      return null;
    }
  }
  inputConnections() {
    return this._inputConnections;
  }
  existingInputConnections() {
    const current_connections = this._inputConnections;
    if (current_connections) {
      while (current_connections.length > 1 && current_connections[current_connections.length - 1] === void 0) {
        current_connections.pop();
      }
    }
    return current_connections;
  }
  addOutputConnection(connection) {
    const output_index = connection.output_index;
    const id = connection.id;
    let connections_by_id = this._outputConnections.get(output_index);
    if (!connections_by_id) {
      connections_by_id = /* @__PURE__ */ new Map();
      this._outputConnections.set(output_index, connections_by_id);
    }
    connections_by_id.set(id, connection);
  }
  removeOutputConnection(connection) {
    const output_index = connection.output_index;
    const id = connection.id;
    let connections_by_id = this._outputConnections.get(output_index);
    if (connections_by_id) {
      connections_by_id.delete(id);
    }
  }
  outputConnectionsByOutputIndex(outputIndex) {
    return this._outputConnections.get(outputIndex);
  }
  outputConnections() {
    let list = [];
    this._outputConnections.forEach((connections_by_id, output_index) => {
      connections_by_id.forEach((connection, id) => {
        if (connection) {
          list.push(connection);
        }
      });
    });
    return list;
  }
}
